import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import Font from "../Font";
export var moaFont = createTheme({
    typography: {
        fontFamily: Font.fontFamily,
        h1: {
            fontWeight: 700,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        },
        body1: {
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        },
        body2: {
            fontWeight: 500,
            fontSize: "0.75rem",
            lineHeight: "0.875rem", /** 14px */
        },
        body3: {
            fontWeight: 400,
            fontSize: "0.688rem",
            lineHeight: "0.875rem", /** 14px */
        },
    },
});
var ThemedComponent = function (props) { return (_jsx(ThemeProvider, { theme: moaFont, children: props.children })); };
export default ThemedComponent;
